// eslint-disable-next-line import/prefer-default-export
export const neutralVehicle1 = {
	itemId: '1',
	productId: 'nf3kfb54bi',
	name: 'Model One',
	basePrice: 8600.0,
	imgUrl: 'https://i.ibb.co/vDkypnf/Group-122.png',
	specs: [
		{
			name: 'Battery',
			price: 800,
			option: '4.3 kWh',
		},
		{
			name: 'Paint job',
			price: 0,
			option: 'black',
		},
	],
	description: 'The brand new Model One. Our fastest, most energy efficient bike to date.',
	oemId: 'neutral-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const neutralVehicle2 = {
	itemId: '2',
	productId: 'nf3kfb54bi',
	name: 'Model One',
	basePrice: 8600.0,
	imgUrl: 'https://i.ibb.co/6ntn4SG/Group-98.png',
	specs: [
		{
			name: 'Battery',
			price: 800,
			option: '4.3 kWh',
		},
	],
	description: 'The brand new Model One. Our fastest, most energy efficient bike to date.',
	oemId: 'neutral-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const neutralPurchasedVehicle = {
	id: '1',
	productId: 'nf3kfb54bi',
	buyerId: 'random-buyer-id',
	placedOrderId: 'random-placed-order-id',
	salesTax: 1000,
	orderFee: 500,
	name: 'Model One',
	basePrice: 8600.0,
	imgUrl: 'https://i.ibb.co/6ntn4SG/Group-98.png',
	specs: [
		{
			name: '4.3 kWh battery upgrade',
			price: 800,
			description: 'Ugraded battery that gives an extra 50 mile range',
		},
		{
			name: 'Black paint job',
			price: 0,
			description: 'Stock paint job',
		},
	],
	description: 'The brand new Model One. Our fastest, most energy efficient bike to date.',
	oemId: 'neutral-manufacturer-id',

	typeOfOrder: 'preorder',
	datePurchased: 1699246800000,
	sectionChoices: {
		registrationAndTitling: {},
		financing: {},
		documentsAndSignatures: {},
		deliveryDetails: {},
		payment: {},
	},
	currentPage: {
		registrationAndTitling: null,
		financing: null,
		documentsAndSignatures: null,
		deliveryDetails: null,
		payment: null,
	},
};

export const onyxVehicle1 = {
	itemId: '1',
	productId: '3243bhdfkdbf',
	name: 'RCR',
	basePrice: 4599.0,
	imgUrl: 'https://cdn.shopify.com/s/files/1/0147/3118/2180/products/Onyx_RCR_Silver_Signal_New_Cover_e6d8a933-9ba7-43f1-812e-6031c7c5923c_2048x2048.png',
	specs: [
		{
			name: 'Battery',
			price: 800,
			option: '4.3 kWh',
		},
		{
			name: 'Paint job',
			price: 0,
			option: 'black',
		},
	],
	description: 'The all-new RCR!',
	oemId: 'onyx-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const onyxVehicle2 = {
	itemId: '2',
	productId: '43br4jhvld4',
	name: 'CTY2',
	basePrice: 3699.0,
	imgUrl: 'https://cdn.shopify.com/s/files/1/0147/3118/2180/products/CTY2_Store_09142022.png',
	description: 'The all new CTY2!',
	specs: [
		{
			name: 'Battery',
			price: 800,
			option: '4.3 kWh',
		},
		{
			name: 'Paint job',
			price: 0,
			option: 'black',
		},
	],
	oemId: 'onyx-manufacturer-id',

	typeOfOrder: 'madeToOrder',
};

export const janusVehicle1 = {
	itemId: '3',
	productId: '2',
	name: 'Halcyon 450',
	basePrice: 14995.0,
	specs: [
		{
			name: 'Gas cap',
			price: 800,
			option: 'custom engraving',
		},
		{
			name: 'Paint job',
			price: 0,
			option: 'black',
		},
	],
	imgUrl: 'https://i.ibb.co/dPLKg9j/image-34.png',
	description: 'The super speedy Halcyon!',
	oemId: 'Janus-manufacturer-id',

	typeOfOrder: 'madeToOrder',
};

export const janusVehicle2 = {
	itemId: '4',
	productId: '32534fdjhif34bif3k4',
	name: 'Halcyon 250',
	basePrice: 8500.0,
	imgUrl: 'https://i.ibb.co/gFp61C1/image-33.png',
	specs: [
		{
			name: 'Gas cap',
			price: 800,
			option: 'custom engraving',
		},
		{
			name: 'Paint job',
			price: 0,
			option: 'black',
		},
	],
	description: 'The all-new Halycon 250!',
	oemId: 'Janus-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const fuellVehicle1 = {
	itemId: '5',
	productId: 'fhbdviruhgi5gbyn4',
	name: 'Fllow',
	basePrice: 11995.0,
	imgUrl: 'https://i.ibb.co/NKj9VFj/Group-97.png',
	specs: [
		{
			name: 'Battery',
			price: 800,
			option: '4.3 kWh',
		},
		{
			name: 'Paint job',
			price: 0,
			option: 'black',
		},
	],
	description: 'The all-new Fuell Fllow!',
	oemId: 'Fuell-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const fuellVehicle2 = {
	itemId: '324',
	productId: 'fhbdviruhgi5gbyn4',
	name: 'Fllow',
	basePrice: 11995.0,
	imgUrl: 'https://i.ibb.co/NKj9VFj/Group-97.png',
	specs: [
		{
			name: 'Blue paint job',
			price: 0,
			option: 'black',
		},
	],
	description: 'The all-new Fuell Fllow!',
	oemId: 'Fuell-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const landVehicle1 = {
	itemId: '6',
	productId: '4324nkjudfg4j',
	name: 'District - Standard',
	basePrice: 7800.0,
	specs: [
		{
			name: 'Battery',
			price: 800,
			option: '4.3 kWh',
		},
		{
			name: 'Paint job',
			price: 0,
			option: 'black',
		},
	],
	imgUrl: 'https://i.postimg.cc/rs47KZck/Group-96.png',
	description: 'The all-new LAND District!',
	oemId: 'land-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const landVehicle2 = {
	itemId: '4328245',
	productId: '4324nkjudfg4j',
	name: 'District - Standard',
	basePrice: 7800.0,
	specs: [
		{
			name: 'Red paint job',
			price: 0,
			option: 'black',
		},
	],
	imgUrl: 'https://i.postimg.cc/rs47KZck/Group-96.png',
	description: 'The all-new LAND District!',
	oemId: 'land-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const curtissVehicle1 = {
	itemId: '7',
	productId: '1',
	name: 'The One',
	basePrice: 125000.0,
	specs: [
		{
			name: 'Battery',
			price: 800,
			option: '4.3 kWh',
		},
		{
			name: 'Paint job',
			price: 0,
			option: 'black',
		},
	],
	imgUrl: 'https://i.ibb.co/qF0cP8F/Group-96-1.png',
	description: 'The all-new Curtiss One!',
	oemId: 'curtiss-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const curtissVehicle2 = {
	itemId: '8',
	productId: '1',
	name: 'The One',
	basePrice: 125000.0,
	specs: [
		{
			name: '2.0 kWh battery',
			price: 800,
			option: 'Ugraded battery that gives an extra 20 miles of range',
		},
		{
			name: 'Paint job',
			price: 0,
			option: 'black',
		},
	],
	imgUrl: 'https://i.ibb.co/qF0cP8F/Group-96-1.png',
	description: 'The all-new Curtiss One!',
	oemId: 'curtiss-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const ryvidVehicle1 = {
	itemId: '9',
	productId: 'anthem',
	name: 'Anthem',
	basePrice: 7800.0,
	specs: [
		{
			name: 'Battery',
			price: 800,
			option: '4.3 kWh',
		},
		{
			name: 'Paint job',
			price: 0,
			option: 'black',
		},
	],
	imgUrl: 'https://powersportsbusiness.com/wp-content/uploads/2022/07/a22JulNews-Anthem.png',
	description: 'The all-new Ryvid Anthem!',
	oemId: 'Ryvid-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const ryvidVehicle2 = {
	itemId: '10',
	productId: 'anthem',
	name: 'Anthem',
	basePrice: 7800.0,
	specs: [
		{
			name: 'Red paint job',
			price: 0,
			option: 'black',
		},
	],
	imgUrl: 'https://powersportsbusiness.com/wp-content/uploads/2022/07/a22JulNews-Anthem.png',
	description: 'The all-new Ryvid Anthem!',
	oemId: 'Ryvid-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const tarformVehicle1 = {
	itemId: '11',
	productId: 'asdaf4f4',
	name: 'Luna',
	basePrice: 28000.0,
	specs: [
		{
			name: 'Battery',
			price: 800,
			option: '4.3 kWh',
		},
		{
			name: 'Paint job',
			price: 150,
			option: 'black',
		},
	],
	imgUrl: 'https://i.ibb.co/9Zrsfrp/Group-107.png',
	description: 'A machine powered by clean technology. Designed to be upgraded. Built to last.',
	oemId: 'tarform-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const tarformVehicle2 = {
	itemId: '11',
	productId: 'asdaf4f4',
	name: 'Luna',
	basePrice: 28000.0,
	specs: [
		{
			name: 'Battery',
			price: 800,
			option: '4.3 kWh',
		},
	],
	imgUrl: 'https://i.ibb.co/9Zrsfrp/Group-107.png',
	description: 'A machine powered by clean technology. Designed to be upgraded. Built to last.',
	oemId: 'tarform-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const mokeVehicle1 = {
	itemId: '12',
	productId: 'dasdsad345f4er',
	name: 'Moke #1',
	basePrice: 29995.0,
	specs: [
		{
			name: 'Battery',
			price: 800,
			option: '4.3 kWh',
		},
	],
	imgUrl: 'https://i.ibb.co/yRWrPDd/Group-110.png',
	// imgUrl: 'https://www.cyclenews.com/wp-content/uploads/2020/10/Zero-Motorcycles-2021-SRS-Cerulean-Blue.png',
	description: 'Inspired by 60 years of innovation.',
	oemId: 'moke-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const mokeVehicle2 = {
	itemId: '13',
	productId: 'dasdsad345f4er',
	name: 'Moke #2',
	basePrice: 29995.0,
	specs: [],
	imgUrl: 'https://i.ibb.co/yRWrPDd/Group-110.png',
	// imgUrl: 'https://www.cyclenews.com/wp-content/uploads/2020/10/Zero-Motorcycles-2021-SRS-Cerulean-Blue.png',
	description: 'Inspired by 60 years of innovation',
	oemId: 'moke-manufacturer-id',

	typeOfOrder: 'preorder',
};

export const voltaVehicle1 = {
	itemId: '14',
	productId: 'voltaVehicleSku',
	name: 'Volta Zero 16T',
	basePrice: 200000.0,
	specs: [
		{
			name: '150-225 kWh battery',
			price: 0,
			option: '',
		},
		{
			name: 'Refrigerated cargo storage',
			price: 0,
			option: '',
		},
		{
			name: 'Ambient cargo storage',
			price: 0,
			option: '',
		},
	],
	imgUrl: 'https://i.ibb.co/SvZPsQM/image-54.png',
	description:
		'The world’s first purpose-built 16-tonne electric truck, revolutionising commercial vehicle operations and delivering a next-generation driving experience.',
	oemId: 'volta-manufacturer-id',

	typeOfOrder: 'preorder',
};
